/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import { ServiceVoModel } from '../service-vo.model';

export class OpportunitySalesServiceVoModel extends JSONable {

  uuid: string | undefined = undefined;

  serviceVO: ServiceVoModel | undefined = undefined;

  constructor(serviceVO: ServiceVoModel) {
    super();

    this.serviceVO = serviceVO;
  }

}
